import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Stack } from "./Stack";
import { type StackDataProps, stackDataSchema } from "./Stack.schema";
import { STACK_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [STACK_TAG_NAME]: { props: StackDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-stack": HTMLElement;
  }
}

function RWCStack({ gap, align }: StackDataProps): JSX.Element {
  return (
    <Stack gap={gap} align={align}>
      <slot />
    </Stack>
  );
}

componentManager.register(
  rwc(STACK_TAG_NAME, {
    component: RWCStack,
    dataSchema: stackDataSchema,
    usesSlots: true,
  }),
);
